import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import { Subscription } from 'rxjs';
import {SERVICE_CONFIG, TaskService} from '../../services/task.service';
import {trigger, state, style, animate, keyframes, transition} from '@angular/animations';
import {NzMessageService} from 'ng-zorro-antd/message';
import {UploadFilter} from 'ng-zorro-antd/upload';
@Component({
  selector: 'nf-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.css'],
  providers: [TaskService],
  animations: [
    trigger('animation', [
      state('open', style({display: 'block'})),
      state('close', style({display: 'none'})),
      transition('open => close', animate('150ms', keyframes([
        style({height: '*'}),
        style({height: '0'})
      ]))),
      transition('close => open', animate('150ms', keyframes([
        style({height: '100px'}),
        style({height: '*'})
      ])))
    ])
  ]
})
export class InfoboxComponent implements OnInit {
  dataSubscription: Subscription = null;
  pulseData: any;
  currentItemId: any;
  infoBoxListData: Array<any> = []; // 存放资料箱数据
  isLoading = false;
  isVisible = false;
  currentInfoId: string;
  total: number;
  pageSize = 10;
  pageIndex = 1;
  prefix;
  uploadFileUrl = SERVICE_CONFIG.baseApi + '/v1/files/upload';
  synchronizeUpdates = false;
  tempData;
  @Input('nfPulseData') set changData(data: any) {
    if (data && JSON.stringify(data) !== '{}') {
      this.pulseData = data;
      this.getInfoBoxList();
    }
  }
  @Input() currentUser = {};
  @ViewChild('auto') auto: ElementRef;
  constructor(
    private msg: NzMessageService,
    private taskService: TaskService
  ) { }
  ngOnInit() {
    this.prefix = this.taskService.getPrefix();
  }
  // 收展信息块
  changeCollapse(id) {
    this.currentItemId = id;
    this.infoBoxListData.forEach((item, index) => {
      if (item.id === id) {
        item.active = !item.active;
      }
    });
  }
  // 初始化富文本
  created(editor) {}
  // 切换编辑状态
  changeEditState(id, type) {
    this.infoBoxListData.forEach((item, index) => {
      if (item.id === id) {
        if (type == 'edit') {
          this.tempData = JSON.stringify(item);
        } else {
          if (this.tempData) {
            const temp = JSON.parse(this.tempData);
            item.title = temp.title;
            item.data = temp.data;
          }
        }
        item.isEdit = !item.isEdit;
      }
    });
  }
  // 添加便签
  addNote(type) {
    const param = {
      'type': type,
      'data': {},
      'title': '标题',
      'active': true,
      'isEdit': true,
      'permissions': 'everyone'
    };
    this.dataSubscription = this.taskService.addInfoBox(this.pulseData.id, param).subscribe((res: any) => {
      if (res) {
        if (this.infoBoxListData) {
          this.infoBoxListData = [
            res,
            ...this.infoBoxListData
          ];
        } else {
          this.infoBoxListData = [res];
        }
      }
    });
  }
  // 修改便签
  doSubmit(type, item) {
    if (!item.data || !item.data.content) {
      this.msg.create('warning', '请输入内容');
      return;
    }
    let param = {
      data: item.data,
      title: item.title,
      pulseId: this.pulseData.id,
      synchronizeUpdates: this.synchronizeUpdates
    };
    this.isLoading = true;
    this.dataSubscription = this.taskService.editInfoBox(this.pulseData.id, item.id, param).subscribe((res: any) => {
      if (res) {
        this.isLoading = false;
        this.msg.create('success', '提交成功');
        item.isEdit = false;
      }
    }, () => {
      this.isLoading = false;
    });
  }
  // 删除资料箱
  deleteInfo(id) {
    this.dataSubscription = this.taskService.deleteInfoBox(this.pulseData.id, id).subscribe((res: any) => {
      this.msg.create('success', '删除成功');
      this.infoBoxListData = this.infoBoxListData.filter((item) => item.id !== id);
    });
  }
  // 编辑标题
  editTile(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
  // 输入框状态
  inputState(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
  // 获取工具箱列表数据
  getInfoBoxList() {
    const param = {
      'page': this.pageIndex,
      'size': this.pageSize
    };
    this.dataSubscription = this.taskService.getInfoBoxData(this.pulseData.id, param).subscribe((res: any) => {
      if (res) {
        this.total = res.page.totalElements;
        this.pageSize = res.page.size;
        this.pageIndex = res.page.number === 0 ? 1 : res.page.number;
        this.infoBoxListData = res.data || [];
      }
    });
  }
  // 上传附件弹窗
  addAttachment(id) {
    this.isVisible = true;
    this.currentInfoId = id;
  }
  // 同步资料箱内容到更新
  syncToUpdate() {

  }
  handleCancel() {
    this.isVisible = false;
  }
  // 处理上传
  uploadFile(event) {
    if (event && event.type === 'success') {
      this.isVisible = false;
      this.msg.create('success', '上传成功');
      let _html = '';
      event.fileList.forEach((file, m) => {
        if (file.response) {
          _html = _html + '<p><a href="'+ this.prefix + '/v1/files/downloads/' + file.response.id + '" target="_blank">' + file.response.name + '</a></p>';
        }
      });
      for (let infoBox of this.infoBoxListData) {
        if (infoBox.id === this.currentInfoId) {
          infoBox.data.content = infoBox.data.content ? infoBox.data.content + _html : _html;
          const fileSet = new Set();
          if (infoBox.data.fileIds) {
            for (let id of infoBox.data.fileIds) {
              fileSet.add(id);
            }
          }
          event.fileList.forEach((file, m) => {
            if (file.response) {
              fileSet.add(file.response.id);
            }
          });
          infoBox.data.fileIds = Array.from(fileSet);
          break;
        }
      }
    }
  }

  pageChange(event) {
    this.pageIndex = event;
    this.getInfoBoxList();
  }
}
